import Highcharts from 'highcharts';
import Data from 'highcharts/modules/data';
import Drilldown from 'highcharts/modules/drilldown';
import pensionForecastGraph from './pension-forecast-graph';
import { App } from '../func/globals/App';

Data(Highcharts);
Drilldown(Highcharts);

App.pensionForecastGraph = pensionForecastGraph;
